var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QSummitStepBackgroundBottom',[_c('QSummitStepBackgroundBottomCenter',{staticClass:"q-summit-step-background-bottom__center"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }